import React, { useEffect, useState } from 'react';
import { CForm, CFormLabel, CFormInput, CButton, CCard, CCardBody, CCardHeader, CCol, CRow, CFormCheck, CNav, CNavItem, CNavLink } from '@coreui/react';
import { Prev } from 'react-bootstrap/esm/PageItem';

// Вкладка "Наявність"
const ProductAvailability = (props) => {
    // console.log('ProductAvailability props', props);

    const [show, setShow] = useState((props.data != undefined && props.data.show != null) ? props.data.show : false);
    const [isTop, setIsTop] = useState((props.data != undefined && props.data.isTop != null) ? props.data.isTop : false);
    const [isDiscontinued, setIsDiscontinued] = useState(props?.data?.discontinued ?? false); // Чи знято з виробництва
    const [isNew, setIsNew] = useState(false);
    const serverIsNew = !!props?.data?.isNew; // Серверне значення для чекбокса новинки як boolean
    const isNewChanged = isNew !== serverIsNew; // Чи змінився чекбокс для новинки відносно серверного значання
    const serverIsTop = !!props?.data?.isTop; // Серверне значення для чекбокса "Топ продаж" як boolean
    const isTopChanged = isTop !== serverIsTop; // Чи змінився чекбокс для "Топ продаж" відносно серверного значання
    const [balance, setBalance] = useState((props.data != undefined && props.data.balance != null) ? props.data.balance : 0);
    const [productToOrder, setProductToOrder] = useState((props.data != undefined) ? props.data.productToOrder : '0');
    const [minBalance, setMinBalance] = useState((props.data != undefined && props.data.minBalance != null) ? props.data.minBalance : 1)
    const [minBalanceAdmin, setMinBalanceAdmin] = useState((props.data != undefined && props.data.minBalanceAdmin != null) ? props.data.minBalanceAdmin : 1)

    // Для checkbox при ініціалазації
    const initProductToOrder = (productToOrder != 1) ? false : true;
    const [changeProductToOrder, setChangeProductToOrder] = useState(initProductToOrder);
    const [categoryIris, setCategoryIris] = useState([]); // Масив категорій в форматі IRI (рядки типу "/api/categories/123") для оновлення в товарі

    // Заповнити значення для чекбокса "Новинка" при оновленні даних товару
    useEffect(() => {
        setIsNew(!!props?.data?.isNew);
    }, [props?.data?.isNew]);

    // Заповнити значення для чекбокса "Топ продаж" при оновленні даних товару
    useEffect(() => {
        setIsTop(!!props?.data?.isTop);
    }, [props?.data?.isTop]);

    // Для зміни значення checkbox для поля "Товар під замовлення"
    useEffect(() => {
        changeProductToOrder ? setProductToOrder(1) : setProductToOrder(0)
    }, [changeProductToOrder]);

    const data_response = {
        isTop: isTop,
        isNew: isNew,
        show: show,
        discontinued: isDiscontinued,
        balance: parseInt(balance),
        productToOrder: parseFloat(productToOrder),
        active: 'on',
        minBalance: parseInt(minBalance),
        minBalanceAdmin: parseInt(minBalanceAdmin),
        ... ((isNewChanged || isTopChanged) ? { category: categoryIris } : {})
    };

    // Розрахувати finallArr тільки коли потрібно (коли змінився isNew відносно сервера)
    useEffect(() => {
        const categoryIdsFromServer = props?.data?.category?.map((elem) => elem.id) ?? [];

        // Якщо якщо не змінилися чекбокси "Новинки" та "Топ продажів" відносно серверного значення - просто віддай серверні категорії
        if (!isNewChanged && !isTopChanged) {
            setCategoryIris(categoryIdsFromServer.map((id) => `/api/categories/${id}`));
            return;
        };

        const novinkiId = props?.novinkiCategoryId;
        const popularniId = props?.popularniCategoryId;
        let ids = categoryIdsFromServer;

        // --- Novinki (isNew) ---
        // Змінюємо лише якщо novinkiId вже відомий
        if (novinkiId) {
            // UI: true, сервер: false -> додати категорію "Новинки"
            // if (isNew && !serverIsNew) {
            if (isNew && !serverIsNew && !ids.includes(novinkiId)) {
                // if (!ids.includes(novinkiId)) ids = [...ids, novinkiId];
                ids = [...ids, novinkiId];
            };

            // UI: false, сервер: true -> прибрати категорію "Новинки"
            if (!isNew && serverIsNew) {
                ids = ids.filter((id) => id !== novinkiId);
            };
        };

        // --- Popularni (isTop) ---
        // Змінюємо лише якщо popularniId вже відомий
        if (popularniId) {
            // UI: true, сервер: false -> додати категорію "Топ продаж"
            if (isTop && !serverIsTop && !ids.includes(popularniId)) {
                ids = [...ids, popularniId];
            };

            // UI: false, сервер: true -> прибрати категорію "Топ продаж"
            if (!isTop && serverIsTop) {
                ids = ids.filter((id) => id !== popularniId);
            };
        };

        setCategoryIris(ids.map((id) => `/api/categories/${id}`));
    }, [
        props?.data?.category,
        props?.novinkiCategoryId, isNew, serverIsNew, isNewChanged,
        props?.popularniCategoryId, isTop, serverIsTop, isTopChanged,
    ]);

    return (
        <div>
            <CForm>
                <div className="mb-3">
                    <CFormCheck id="exampleFormControlInput8" label="Товар продається" checked={show} onChange={() => setShow(!show)} />
                </div>
                <div className="mb-3">
                    <CFormCheck id="exampleFormControlInput9" label="Топ продаж" checked={isTop} onChange={() => setIsTop(prev => !prev)} />
                </div>
                <div className="mb-3">
                    <CFormCheck id="exampleFormControlInput10" label="Новинка" checked={isNew} onChange={() => setIsNew(prev => !prev)} />
                </div>
                <div className="mb-3">
                    <CFormCheck id="exampleFormControlInput12" label="Товар під замовлення" checked={initProductToOrder} onChange={() => setChangeProductToOrder(!changeProductToOrder)} />
                </div>
                <div className="mb-3">
                    <CFormCheck id="exampleFormControlInput13" label="Знято з виробництва" checked={isDiscontinued} onChange={() => setIsDiscontinued(!isDiscontinued)} />
                </div>

                <div className='row'>
                    <div className='col'>
                        <div className="mb-3">
                            <CFormLabel htmlFor="exampleFormControlInput1">Баланс</CFormLabel>
                            <CFormInput type="number" id="exampleFormControlInput6" value={balance == null ? "" : balance} onChange={(e) => setBalance(e.target.value)} autoComplete="off" />
                        </div>
                    </div>
                    <div className='col'>
                        <div className="mb-3">
                            <CFormLabel htmlFor="exampleFormControlInput1">Мінімальна кількість (сайт)</CFormLabel>
                            <CFormInput type="number" id="exampleFormControlInput6" value={minBalance == null ? "" : minBalance} onChange={(e) => setMinBalance(e.target.value)} autoComplete="off" />
                        </div>
                    </div>
                    <div className='col'>
                        <div className="mb-3">
                            <CFormLabel htmlFor="exampleFormControlInput1">Мінімальна кількість  (інформувати в  боті) </CFormLabel>
                            <CFormInput type="number" id="exampleFormControlInput6" value={minBalanceAdmin == null ? "" : minBalanceAdmin} onChange={(e) => setMinBalanceAdmin(e.target.value)} autoComplete="off" />
                        </div>
                    </div>
                </div>
                <CButton color="success" onClick={(event) => props.handleSubmit(event, data_response)}>Зберегти</CButton>
            </CForm>
        </div>
    );
};

export default ProductAvailability;